import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { FormProvider, useForm, useWatch } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import TabPanel from "../Reusable/Tab";
import { createShiftValidationForm } from "../../utils/validationSchemas";
import ShiftForm from "./ShiftForm";
import { useEffect } from "react";

const EditShift = (props: any) => {
  const { profile, handleEdit, isLoading, refetch } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
    reset,
  } = useForm({
    resolver: yupResolver(createShiftValidationForm),
    defaultValues: async () => {
      let data: any = await refetch();
      console.log(data);
      return {
        ...data?.data,
      };
    },
  });

  console.log(profile, "profile");

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <ShiftForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
          watch={watch}
          profile={profile}
        />
      </FormLayout>
    </>
  );
};

export default EditShift;
//   useEffect(() => {
//     if (profile) {
//       reset({
//         ...profile,
//       });
//     }
//   }, [profile, reset]);
